/**
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import is_js from "is_js";

import NoSleep from "../utils/nosleep/index.js";
//import { Actions } from 'react-native-router-flux';
import { languageManager } from "../utils/languageManager";
import { flipwitFirebaseConnector } from "../platforms/flipwitFirebaseConnector";
//import { localHandler } from '../local/LocalHandler'
import { autoviewer } from "../autoViewer/AutoViewer";
import { auditorium } from "../auditorium/Auditorium";
import { userHandler } from "../platforms/UserHandler";
import { SceneManager } from "../utils/sceneManager";

import { PlatformEnum, ID_SLIDE_COMMENT } from "../App/constants";
import { requestPostSail } from "../utils/requester";
import {
  setPPTsOpen,
  setSelectedPPT,
  setPPTsCloud,
  setSessionCode,
  setAmountConnections,
  setTitleBar,
  setSlideIndex,
  setSlideInfo,
  setStaticSlideInfo,
  setSlidePreview,
  setStateLoadingPresentation,
  setLanguage,
  setSharePPT,
  setSubmenuInfo,
  setPresentationModeConfig,
  setDataPresentation,
  setHotPluginInfo
} from "../App/actions";
//import { LiterallyCanvas } from 'literallycanvas'
//import LiterallyCanvas from "literallycanvas/lib/js/core/LiterallyCanvas";

import LiterallyCanvas from "../utils/literallycanvas-core";

//Antes se podia presentar y todo desde el electron, al hacer el cambio para que el electron solo sirva para poder subir PPT entonces
//se creo esto para que sea facil regresar al anterior
let shouldBlockExhibitForElectron = true;

let webCompile = false; //para subir a la pagina esta variable tiene que estar en true y comentar la linea del import de localhandler
let localHandler;
// Initializes PlatformHandler.
export class PlatformHandler {
  constructor() {
    window.platformHandler = this;
    //Si se pone el modo demo este null se reemplaza por un objeto con la informacion
    this.demoMode = null;
    this.demoUserName = "demo-zpey";

    this.noSleepEnabled = false;

    this.inSlideShowMode = false;
    this.infoActivities = null;
    this.slidesNotes = null;
    this.slidesData = [];
    this.IStartedPresentation = false;
    this.isDonePresentation = false;
    this.dataConnector = null;
    //this.titleBarHeight = 0;
    this.previous = 0;

    this.isLocalSession = false; //si va a ejecutar sobre una local
    this.isLAN = false; //si va a ejecutar sobre una local

    this.noSleep = new NoSleep();
    this.instanceNumber = new Date().getTime();
    this.logNumber = 0;

    this.sceneManager = new SceneManager();

    /* variables que se pasaron a manejarse solo con el store
    this.pptName = ""; //X
    this.isCloudPresentation = false;//X
    this.codeSession = ""; //X
    this.currentSlideIndex = -1; //X
    this.currentIdActivity = ""; //X
    this.currentPreview = ""; //X
    this.totalSlides = 0; //X*/

    this.listenerState = null;
    this.dispatch = null; //funcion para cambiar estado
    this.getState = null; //funcion para obtener estado
    this.initInformation = null;
    this.currentScene = "";
    this.cloudPresentationID = null;

    this.listenersUsers = [];

    //Variable que indica si la sesion actual cuenta o no con un cliente electron o si corre solo con clientes moviles
    //this.electronSession = false;

    //En este listener de GUI se pasa la informacion de cambios por ejemplo del preview a mostrar actualmente
    this.listenerForData = null;
    this.listenFullScreen = null;
    this.currentStateFirebase = {};
    this.slidesImgDrawing = [];
    this.lc = null; //canvas de dibujo
    this.updatePointer = null; //cb para cambiar puntero
    this.initDrawer = null; //cb para que reinicie el canvas si se cambiar la orientacion

    this.ready = false;
    this.nick = "";
    this.showJoinOptions = false;

    this.firstStateProcessed = false;
    this.isMobile = this.mobilecheck();
    this.isMobileAndTablet = this.mobileAndTabletcheck();
    console.log("this.isMobile " + this.isMobile);

    let ClockManager = require("../utils/ClockManager.js");
    this.presentationClockManager = new ClockManager();

    //La configuracion que tiene en bd la presentacion actual
    this.currentSlidesConfig = {};
  }

  blockExhibitForElectron() {
    return (
      shouldBlockExhibitForElectron &&
      this.isElectron &&
      flipwitFirebaseConnector.currentUser.is_auditorium !== true
    );
  }

  mobilecheck() {
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      return true;
    } else {
      return false;
    }
  }

  mobileAndTabletcheck() {
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      return true;
    } else {
      return false;
    }
  }

  init(isElectron, timeScriptWSH, history) {
    console.log("the history", history);
    this.isElectron = isElectron;

    if (window.location.href !== "http://localhost:3000/") {
      //para probar web local
      if (!isElectron && window.location.hostname.indexOf("flipwit") < 0) {
        /*this.isLAN = true;
       this.isLocalSession = true;//*/
      }
    }

    //this.electronSession = true;
    this.currentPlatform = PlatformEnum.ANDROID;
    this.isExhibitor = true; //MODIFIED ADDED, se coloca siempre en true por si ya esta logueado y es anonimo no lo lance para la de presentation

    //TODO if (Platform.OS === 'web'){
    this.currentPlatform = PlatformEnum.WEB;

    if (this.isElectron) {
      this.currentPlatform = PlatformEnum.ELECTRON;
    }
    // }

    switch (this.currentPlatform) {
      case PlatformEnum.ANDROID:
      case PlatformEnum.IOS:
        break;

      case PlatformEnum.WEB:
        let handlerJS = require("./web/WebHandler.js");
        this.osHandler = handlerJS.default();
        break;

      case PlatformEnum.ELECTRON:
        handlerJS = require("./electron/ElectronHandler.js");
        this.osHandler = handlerJS.default();

        if (!webCompile) {
          this.FlipwitSlideConnector = {};
          let FlipwitSlideConnectorGeneral = require("./electron/js/powerpoint/FlipwitSlideConnectorGeneral.js");
          this.FlipwitSlideConnector = FlipwitSlideConnectorGeneral.default();
          this.FlipwitSlideConnector.init(timeScriptWSH);
        }
        break;

      default:
    }

    this.startDataConnector();
  }

  showGeneralError = error => {
    console.log(
      "Llama a un error general que se deberia mostrar en pantalla pero no se ha implementado eso",
      error
    );
  };

  //Funcion para poder probar directamente la pantalla de presentationMode
  createDummyData() {
    //this.presentationStarted( 'DarDandoVr2.pptx', true, '5b9936e142216a0383e305c4' );
    this.presentationStarted(
      "Flipwit_Profesores.pptx",
      true,
      "5990cb823e5a44d9182b7fcc"
    );

    //this.slidesData = {"idSlide":1,"md5":"3f06ec6073d909a20bc136b8bb71ecdf","note":"","url":"https://firebasestorage.googleapis.com/v0/b/toglea-9fec0.appspot.com/o/cbeltran%2FDarDandoVr2.pptx%2F1.jpg?alt=media&token=bf3fc865-d655-40a4-8835-375606041b71"},{"idSlide":2,"md5":"dca75e8cef8b532e0bf6838ffeac4fb6","note":"","url":"https://firebasestorage.googleapis.com/v0/b/toglea-9fec0.appspot.com/o/cbeltran%2FDarDandoVr2.pptx%2F2.jpg?alt=media&token=06821cc7-3896-4913-aa84-41e0b7b8f004"},{"idSlide":3,"md5":"afb138c557198e5113dd23a566d3b93b","note":"","url":"https://firebasestorage.googleapis.com/v0/b/toglea-9fec0.appspot.com/o/cbeltran%2FDarDandoVr2.pptx%2F3.jpg?alt=media&token=6ed35484-a690-490d-9579-7dbd05d124bf"},{"idSlide":4,"md5":"73e92f1cb036962c3f79c97ff2a02c7e","note":"","url":"https://firebasestorage.googleapis.com/v0/b/toglea-9fec0.appspot.com/o/cbeltran%2FDarDandoVr2.pptx%2F4.jpg?alt=media&token=5676b50e-118d-4dee-9e09-9db8e15dad96"},{"idSlide":5,"md5":"a9e8a8b958421d5fd8e8d79d348214ae","note":"","url":"https://firebasestorage.googleapis.com/v0/b/toglea-9fec0.appspot.com/o/cbeltran%2FDarDandoVr2.pptx%2F5.jpg?alt=media&token=408df39b-61c1-4938-ab1e-56638bdd5637"},{"idSlide":6,"md5":"4eba2893efaf6f661667664fecc77af5","note":"","url":"https://firebasestorage.googleapis.com/v0/b/toglea-9fec0.appspot.com/o/cbeltran%2FDarDandoVr2.pptx%2F6.jpg?alt=media&token=dd143741-d417-40f3-b888-5c498b49606e"},{"idSlide":7,"md5":"176198940eea3fa771f9f9700717b8ad","note":"[TOGLEA]-5b8f5ad17af9d74ec71df171\r\r59bfebd659cb845c338393bb\r\rhttps://dardando.com/whatsAppButton/dardando/","url":"https://firebasestorage.googleapis.com/v0/b/toglea-9fec0.appspot.com/o/cbeltran%2FDarDandoVr2.pptx%2F7.jpg?alt=media&token=846fa6a2-f3e3-4a31-bff0-176867760796"},{"idSlide":8,"md5":"176198940eea3fa771f9f9700717b8ad","note":"[TOGLEA]-5b8f5f1cffd38c1376077dde\r\r59bfebd659cb845c338393bb\r\rhttps://docs.google.com/forms/d/e/1FAIpQLSfLRR0Gmt8jKhOzdV1788_UsWTDRodQ5kVcXI4JdSWULvyXIQ/viewform?embedded=true","url":"https://firebasestorage.googleapis.com/v0/b/toglea-9fec0.appspot.com/o/cbeltran%2FDarDandoVr2.pptx%2F8.jpg?alt=media&token=39149260-ab0b-4030-a67e-b2ef7cd37b07"};
  }

  startDataConnector() {
    if (this.isLAN) {
      this.dataConnector = localHandler;
    } else {
      this.dataConnector = flipwitFirebaseConnector;
    }

    this.dataConnector.init();
  }

  signInGoogle() {
    this.osHandler.signInGoogle();
  }

  signInWithEmailAndPassword(userdata) {
    return this.osHandler.signInWithEmailAndPassword(userdata);
  }

  fetchSignInMethodsForEmail(email) {
    console.log(this.osHandler);
    return this.osHandler.fetchSignInMethodsForEmail(email);
  }

  joinPresentation(code, callback) {
    var payload = {
      code: code
    };

    console.DEBUG_FLIPWIT("llama a url de sails para unir a sesion");

    this.isExhibitor = false;
    this.callbackJoinFn = callback;
    requestPostSail(
      process.env.REACT_APP_URL_SERVICES + "session/getInfo",
      payload,
      this.callbackJoin
    );
  }

  JoinWithNick(nick) {
    this.nick = nick;
    //comprobar que ya esta logueado, si ya lo esta no deja loguearse de nuevo
    if (flipwitFirebaseConnector.checkSignedIn()) {
      if (flipwitFirebaseConnector.isAnonymous()) {
        flipwitFirebaseConnector.setAnonymousNick();
        this.sceneManager.openScene("PresentationUser");
      }
    } else {
      this.signInAnonymously();
    }
  }

  callbackJoin = data => {
    console.log("DATA JOIN", data);
    if (this.callbackJoinFn) {
      this.urlWait = data.urlWait;
      this.hasDomain = data.domain;
      this.callbackJoinFn(data);
    }
  };

  setDataAudience = (email, name) => {
    this.emailUser = email.replace(/ /g, "");
    this.nameUser = name;
    this.setDataSession();
  };

  setDataSession = () => {
    this.setSession(this.dataSession.resp.code);
    this.setCodeInUrl(this.dataSession.resp.code);

    //console.log("Por aca a setDataSession con ",flipwitFirebaseConnector.checkSignedIn() , ! flipwitFirebaseConnector.isAnonymous())

    if (
      flipwitFirebaseConnector.checkSignedIn() &&
      !flipwitFirebaseConnector.isAnonymous()
    ) {
      this.sceneManager.openScene("PresentationUser");
    } else {
      //si no esta logueado abra la pantalla de loguearse o colocar el nick
      if (this.showJoinOptions) {
        this.sceneManager.openScene("JoinOptions");
      } else {
        this.JoinWithNick("Anonimo " + Date.now());
      }
    }
  };

  joinSession(data) {
    if (data.success) {
      this.dataSession = data;

      if (
        (data.resp.shareFinish || data.resp.config.nick) &&
        !this.isLoggedIn()
      ) {
        this.sceneManager.openScene("ShareOption", {
          config: data.resp.config
        });
      } else {
        this.setDataSession();
      }
    }
  }

  setCodeInUrl(code) {
    if (
      !(
        window.codeByUrl !== "" &&
        window.codeByUrl !== null &&
        window.codeByUrl !== undefined
      )
    ) {
      var url_origin = window.location.origin;
      window.history.pushState({}, url_origin, url_origin + "/" + code);
    }
  }

  getUserUid = () => {
    return flipwitFirebaseConnector.getUserUid();
  };

  getFullUserUid = () => {
    return flipwitFirebaseConnector.getFullUserUid(
      this.getStoreData().idUserPresentation
    );
  };

  authStateChanged(user) {
    console.DEBUG_FLIPWIT("loguea:" + (user ? user.uid : false));

    console.log("user", user);
    console.log("Ready?", this.ready);
    this.user = user;

    if (!this.ready) {
      //es la primera vez entonces cargue la pantalla de role
      this.ready = true;
      if (this.isLAN) {
        localHandler.startApp();
      } else {
        if (this.isElectron && webCompile) {
          this.sceneManager.openScene("MessageUser");
        } else {
          //Si esta en modo demo inicia la presentacion
          if (this.demoMode !== null) {
            this.demoMode.authInfo = true;
            this.initDemo();
            return;
          }

          //TODO2 Quitar y poner lo otro
          //this.sceneManager.openScene("Role");

          const hasWindowCode =
            window.codeByUrl != "" &&
            window.codeByUrl != null &&
            !platformHandler.isLAN;

          //console.log('TERMINA AUTH CON ',flipwitFirebaseConnector.checkSignedIn(),flipwitFirebaseConnector.isAnonymous(),hasWindowCode);
          //Lo siguiente se debe decomentar al terminar
          //Si ya esta logueado lo lleva de una a la pantalla de seleccionar presentacion, pero pasando por el flujo normal
          if (
            flipwitFirebaseConnector.checkSignedIn() &&
            !flipwitFirebaseConnector.isAnonymous() &&
            !hasWindowCode
          ) {
            this.startWithInternet(true);
            this.startExhibiting();

            if (this.isElectron && user.is_auditorium) {
              this.sendToTray();
              this.reportPresence();
            }

            /*this.initEditor(
              "26862749-26863388-RKDDIADCWCIQXWIYWGSD26863388.pdf",
              "5e63a86507f5bda23d38f565"
            );*/
          } else {
            //La pantalla del electron no pasa por la de Rol, lleva de una a Login
            if (this.isElectron) {
              this.sceneManager.openScene("Login");
            } else {
              this.sceneManager.openScene("Role");
            }
          }
        }
      }
      return;
    }

    if (this.isLocalSession) {
      localHandler.startApp();
    } else {
      //si es diferente de esto es porque ya se inicio la sesion como expositor y lo que hizo
      //fue una reconexion
      if (this.currentExhibitorScreen !== "") {
        return;
      }

      if (user) {
        if (this.isExhibitor) {
          if (!user.isAnonymous && user.active === "y") {
            if (this.blockExhibitForElectron()) {
              this.startExhibiting();
            } else {
              console.log("LLEGA A QUE REPORTE!!");
              this.reportPresence();
            }
          } else {
            this.sceneManager.openScene("BlockedUser"); // we need to create this Scene!!!
          }
        } else {
          this.sceneManager.openScene("PresentationUser");
        }
      }
    }
  }

  //Si existe ya el valor de la configuracion entonces retorna el valor encontrado
  //sino entonces retorna null
  getUserConfig(key) {
    //Hace fake de la configuración para el modo demo
    if (this.demoMode) {
      switch (key) {
        case "tutorial_start_presentation_finished":
          return true;
        case "tutorial_select_presentation_finished":
          return true;
        default:
          return false;
      }
    }

    console.log("Primero es", this.user);
    console.log("PIDEEEE KEY", key, this.user.config[key]);

    if (!this.user) return null;

    if (this.user.config[key] !== undefined) {
      //esto es temporal para que solo le salga el tutorial a los que en base de datos lo tengan
      //como ya terminado (lo contrario a lo real), lo hago para poder mostrarle a Paula como
      //funciona
      if (key === "tutorial_start_presentation_finished") {
        //return !this.user.config[key];
      }

      return this.user.config[key];
    } else {
      //esto es temporal para que solo le salga el tutorial a los que en base de datos lo tengan
      //como ya terminado (lo contrario a lo real), lo hago para poder mostrarle a Paula como
      //funciona
      if (key === "tutorial_start_presentation_finished") {
        //return true;
      }
      return null;
    }
  }

  setUserConfig(key, val) {
    this.user.config[key] = val;

    var payload = {
      userFirebase: this.user.username,
      config: this.user.config
    };

    console.log("Envio de ", payload);

    requestPostSail(
      process.env.REACT_APP_URL_SERVICES + "user/setUserConfig",
      payload,
      data => {
        console.log("USER CONFIG STORED", data);
      }
    );
  }

  sendToTray = () => {
    const remote = window.require("electron").remote;
    remote.app.sendToTray();

    this.auditoriumAction("setMode", true);
  };

  async executeCommand(command) {
    console.DEBUG_FLIPWIT(
      "Ejecutar comando " + command.interactionType + " con " + this.isCloud()
    );
    if (!this.isCloud()) {
      if (this.lockSendCommand) {
        console.log("LOCKED");
        return;
      }

      this.osHandler.executeCommand(command);

      if (this.currentPlatform === PlatformEnum.WEB) {
        this.lockSendCommand = true;
      }
    } else {
      if (command.command === "InteractionFeature") {
        console.DEBUG_FLIPWIT(
          "Ejecuto comando " +
            command +
            " pero esta sesion no tiene un cliente Electron"
        );

        switch (command.interactionType) {
          case "Init":
            console.DEBUG_FLIPWIT(
              "Quiero iniciar como cloud a la presentacion " +
                this.cloudPresentationID
            );
            this.dispatch(
              setStateLoadingPresentation(
                languageManager.getLangWord("LOADING_INFO")
              )
            );
            var payload = {
              id: this.cloudPresentationID,
              user: flipwitFirebaseConnector.loggedUser
            };

            //Para el modo demo hace un fake del usuario para poder obtener los datos
            if (this.demoMode !== null) {
              payload.user = "demo-zpey";
            }

            requestPostSail(
              process.env.REACT_APP_URL_SERVICES + "slides/getPresentationInfo",
              payload,
              data => {
                console.DEBUG_FLIPWIT(
                  "llega de sails la presentation info de " +
                    data.name +
                    "\n this.codeSession nuevo " +
                    this.getSessionCode() +
                    "<>",
                  JSON.stringify(data)
                );

                this.setCurrentSlidesConfig(data.config);

                this.setPPTName(data.name);
                if (this.getSessionCode() === "") {
                  this.setSlidePosition(1, false);
                }
                this.initInformation = data;
                console.log(
                  "firstStateProcessed ",
                  this.firstStateProcessed,
                  data
                );
                if (this.firstStateProcessed) {
                  console.DEBUG_FLIPWIT("DESDE INIT " + this.getSessionCode());
                  this.processInitInformation();
                }
              }
            );
            break;

          case "Next":
            let indexTemp = this.getSlideIndex();
            console.DEBUG_FLIPWIT(
              "me iria para " +
                (indexTemp + 1) +
                " y puedo hasta < " +
                (this.slidesNotes.length + 1)
            );
            if (indexTemp + 1 < this.slidesNotes.length + 1) {
              this.setIndex(indexTemp + 1);
              await this.checkCurrentSlide();
            }
            break;

          case "Prev":
            indexTemp = this.getSlideIndex();
            console.DEBUG_FLIPWIT(
              "me iria para " + (indexTemp - 1) + " y puedo hasta > 0"
            );
            if (indexTemp - 1 > 0) {
              this.setIndex(indexTemp - 1);
              await this.checkCurrentSlide();
            }
            break;

          case "Goto":
            indexTemp = this.getSlideIndex();
            let newIndex = command.newIndex;
            console.DEBUG_FLIPWIT(
              "me iria para " +
                newIndex +
                " y puedo hasta < " +
                (this.slidesNotes.length + 1)
            );
            if (newIndex < this.slidesNotes.length + 1 && newIndex > 0) {
              this.setIndex(newIndex);
              await this.checkCurrentSlide();
            }
            break;

          case "Finish":
            this.slideShowEnds();
            break;

          default:
        }
        //TODO Aca se supone que llega cuando se ejecuto un comando como por ejemplo NEXT pero
        //es una presentacion flipwit iniciada sin electron ni powerpoint
        //ademas debe llamar setSlidesData(data) con los datos de los slides
      }
    }
  }

  insertActivity(id, urlImg, pptName, comment = "", webView = null) {
    this.isElectron
      ? this.osHandler.insertActivity(id, urlImg, pptName, comment, webView)
      : this.slideEditor
      ? this.slideEditor.insertActivity(id, urlImg, pptName, comment, webView)
      : null;
  }

  startExhibiting() {
    this.isExhibitor = true;
    if (this.isLAN) {
      if (this.isElectron) {
        this.sceneManager.openScene("SelectPresentation");
      } else {
        localHandler.getCurrentScreen();
      }

      this.listenUserConnections();
    } else {
      if (this.demoMode !== null) {
        this.reportPresence();
        return;
      }

      //si esta logueado y no es anonimo...
      if (
        flipwitFirebaseConnector.checkSignedIn() &&
        !flipwitFirebaseConnector.isAnonymous()
      ) {
        console.log(
          "ALGO VA A HACER DE OBTENER COSAS",
          flipwitFirebaseConnector
        );

        console.log(
          "Subscription user: " + flipwitFirebaseConnector.currentUser
        );
        if (flipwitFirebaseConnector.currentUser.active === "y") {
          console.log("El usuario es ", flipwitFirebaseConnector.currentUser);

          /*TODO BELTRAN, Carva será que asi? solo validando que el usuario no sea auditorio*/
          //Si estamos en el electron y el no debe tener funciones de exhibidor entonces no reporta la presencia
          if (this.blockExhibitForElectron()) {
            this.sceneManager.openScene("UploadPresentation");
            return;
          }

          this.reportPresence();
        } else {
          this.sceneManager.openScene("BlockedUser");
        }
      } else {
        // platformHandler.signInGoogle();
        this.sceneManager.openScene("Login");
      }
    }
  }

  // Dice que reporte y escuche la presencia de esta conexion y le pasa null ya que soy el expositor
  // entonces no me uno a una presentacion sino que uso mi propio id
  // 18-oct-2017: Promisified everything to avoid random behaviors crating all listeners
  reportPresence = () => {
    //si es auditorio no bloquee el reporte de la presencia
    if (!this.isAuditoriumMode()) {
      //El electron ya no reporta presencia
      if (this.blockExhibitForElectron()) {
        this.sceneManager.openScene("SelectPresentation");
        return;
      }
    }

    console.log("reportPresence");
    this.reportAndListenPresence(null, "Presenter").then(() => {
      this.waitingForFirstPresenceInfo = true;

      flipwitFirebaseConnector
        .listenAllExhibitorPresence(this.callbackAllPresence)
        .then(() => {
          this.listenUserConnections().then(
            flipwitFirebaseConnector.loadMessages()
          );
        });
    });
  };

  // @return Promise
  listenUserConnections = (idUserPresentation = null) => {
    return this.dataConnector.listenUserConnections(
      this.callbackUserConnections,
      idUserPresentation
    );
  };

  // @return Promise
  reportAndListenPresence = (idPresentation, nickname) => {
    if (this.isLAN) {
      this.listenUserConnections();
    } else {
      return flipwitFirebaseConnector.reportAndListenPresence(
        idPresentation,
        nickname
      );
    }
  };

  callbackAllPresence = (
    allConnections,
    amountConnections,
    thisConnectionID
  ) => {
    console.log(
      "Llega con amount connections",
      amountConnections,
      this.getUserConfig("tutorial_start_presentation_finished"),
      this.tutorial_start_second_part,
      this.presentationModeScreen
    );

    //Si llega una segunda conexion y no ha terminado el tutorial de inicio entonces
    //va al siguiente paso pero si tiene pantalla de presentationMode, si no la tiene es porque
    //este codigo se esta ejecutando en el segundo dispositivo, por lo que el tutorial queda en
    //otro estado, es decir, para el primer conectado cambia de paso y para el segundo conectado
    //hace lo otro, el segundo todavia no va a tener la pantalla de presentationMode cargada
    //porque apenas el siguiente if(this.waitingForFirstPresenceInfo) va a pedir al firebase
    //en que pantalla esta y luego va a cambiar ahi si a la pantalla de presentationMode donde
    //esta leera la variable que se setea de secondConnectedPresentationMode
    if (
      amountConnections >= 2 &&
      !this.getUserConfig("tutorial_start_presentation_finished")
    ) {
      if (this.presentationModeScreen) {
        this.presentationModeScreen.cambiarPasoTutorial(1);
      } else {
        this.tutorial_start_second_part = true;
      }
    }

    if (this.waitingForFirstPresenceInfo) {
      console.DEBUG_FLIPWIT("cantidad: " + amountConnections);
      ///if(amountConnections>1) {
      console.DEBUG_FLIPWIT(
        "dice que escuche a currentScreen teniendo a " +
          this.currentExhibitorScreen
      );
      flipwitFirebaseConnector.listenCurrentExhibitorScreen();
      /*}
      else {
        this.sceneManager.openScene("SelectPresentation"); 
        this.waitingForFirstPresenceInfo = false;       
      }  // */
    }

    console.log("SETEE amountConnections", amountConnections);
    this.amountConnections = amountConnections;
    console.log("quedo amountConnections", this.amountConnections);
  };

  callbackUserConnections = (allUserConnections, amountConnections) => {
    console.log(
      "Setea amount como ",
      amountConnections,
      " y ",
      allUserConnections
    );

    try {
      this.dispatch(setAmountConnections(amountConnections - 1));
    } catch (ex) {
      console.log("Error en connections", ex);
    }

    this.allUserConnections = allUserConnections;

    /*if( this.isExhibitor && this.currentExhibitorScreen == "PresentationMode" ){
      if( this.currentStateFirebase.communData ){
        this.currentStateFirebase.usersCon = this.getUsersConnected();
        this.sendState(this.currentStateFirebase);
      }
    }*/
    this.listenersUsers.forEach(listenerRef => listenerRef(allUserConnections));

    //Si esta en modo demo
    if (this.demoMode !== null) {
      this.processDemoEvent("newConnection", {
        allUserConnections: allUserConnections,
        amountConnections: amountConnections
      });
    }
  };

  sendState = stateData => {
    this.dataConnector.sendState(stateData);

    //Actualiza la informacion a enviar en la pantalla
    if (this.listenerState !== null && this.listenerState !== undefined)
      this.listenerState(true, stateData);
  };

  sendStaticState(staticStateData) {
    this.dataConnector.sendStaticState(staticStateData);

    //Actualiza la informacion a enviar en la pantalla
    if (this.listenerState !== null && this.listenerState !== undefined) {
      staticStateData.isStaticInfo = true;
      this.listenerState(true, staticStateData);
    }
  }

  //Funcion que se llama en todos los clientes cuando se termino la sesion del expositor
  sessionClosed() {
    console.DEBUG_FLIPWIT("Se cerro la sesion del presentador");
    this.updateSessionClose();

    if (this.isExhibitor) {
      this.sceneManager.openScene("SelectPresentation");
    } else {
      //si es domain mirar si tiene url wait
      if (this.urlWait) {
        //avisar que no hay firebase datos para que cierre la sesion en el servidor
        this.noSessionForDomain(window.codeByUrl);
        this.openWaitingScreen(this.urlWait);
      } else {
        window.codeByUrl = "";
        this.sceneManager.openScene("Role");
      }
    }
  }

  updateSessionClose() {
    console.DEBUG_FLIPWIT("ENTRA A ACTUALIZAR SLIDE DATA");
    if (!this.isLAN) {
      this.setSession("");
    }
    this.setPPTName("");
    this.stopClock();
    let initState = {
      communData: {
        idToglea: "",
        url: "",
        slideIndex: "-1",
        titleToglea: "",
        infoToglea: "",
        previewUrl: process.env.REACT_APP_URL_SERVICES + "images/nopreview.png"
      }
    };

    this.dispatch(setSlideInfo(initState));
  }

  setListenerPresentationClock(listener) {
    this.presentationClockManager.setTimeListener(listener);
  }

  setListenerPresentation = (listener, idUserPresentation) => {
    console.log("Coloca listeners de presentacion");
    this.listenerState = listener;
    if (!this.isCloud() && !this.isElectron) {
      this.dispatch(
        setStateLoadingPresentation(
          languageManager.getLangWord("STATES_INIT_PRESENTATION.0")
        )
      );
    }
    this.previous = 0;
    this.dataConnector.loadPresentationMsgs(
      this.listenerForStateChange,
      idUserPresentation,
      this.getSessionCode()
    );
    this.dataConnector.loadPresentationStaticState(
      this.listenerForStateChange,
      idUserPresentation,
      this.getSessionCode()
    );
    if (this.isExhibitor) {
      this.dataConnector.loadImgsDrawings(
        this.listenerForDrawingsData,
        idUserPresentation
      );
    }
  };

  listenerForStateChange = (success, data) => {
    //Si yo soy electron y ademas estamos en una session que no es de nube (con un ppt de powerpoint) entonces
    //ignora el estado ya que el mismo es el que lo envió

    if (this.isExhibitor) {
      this.checkPointer(data);
      if (!this.isCloud() && this.isElectron) {
        if (data !== undefined && data !== null && data.communData) {
          this.updateListenerCurDrawing();
        }
        return;
      }
    }

    if (data !== undefined && data !== null && data.isStaticInfo) {
      if (this.isLAN) {
        this.presentationClockManager.start(Date.now() - data.initTime);
      } else {
        console.DEBUG_FLIPWIT("Llego al state static");
        flipwitFirebaseConnector.getCurrentServerTime(offset => {
          this.presentationClockManager.start(
            Date.now() - data.initTime + offset
          );
          console.DEBUG_FLIPWIT(
            "Inicio hace " + data.initTime + " Llega offset " + offset
          );
        });
      }

      this.setSession(data.code);
      this.dispatch(setStaticSlideInfo(data));
    } else {
      console.DEBUG_FLIPWIT("DATA listenerForStateChange");
      if (this.isExhibitor) {
        if (this.isLAN) {
          this.nextPreviewLan = "";
          if (data.communData.nextPreview) {
            this.nextPreviewLan = data.communData.nextPreview;
          }
        }

        if (
          data !== undefined &&
          data !== null &&
          data.communData &&
          this.firstStateProcessed === false
        ) {
          console.log("pimero");
          this.setSlidePosition(data.communData.slideIndex, false);
          this.updateListenerCurDrawing();

          if (
            (this.isLAN && !this.isElectron) ||
            (!this.isCloud() && !this.isElectron)
          ) {
            this.dispatch(setSlideInfo(data));
          }
        } else {
          console.log("segunod ", data);
          if (data !== undefined && data !== null && data.communData) {
            console.log(
              "here " + data.communData.slideIndex + " " + this.getSlideIndex()
            );
            if (
              data.communData.slideIndex !== this.getSlideIndex() ||
              data.communData.previewUrl !== this.getCurrentPreview()
            ) {
              this.dispatch(setSlideInfo(data));
            }
            this.updateListenerCurDrawing();
          }
        }
      } else {
        if (data !== undefined && data !== null && data.communData) {
          if (data.pointer && data.pointer.visible) {
            this.checkPointer(data);
            return;
          } else {
            this.dispatch(setSlideInfo(data));
          }
        }
      }

      this.firstStateProcessed = true;

      if (this.initInformation) {
        this.processInitInformation();
      }
    }

    this.lockSendCommand = false;
    this.listenerState(success, data);
  };

  setListenerForData(listener) {
    this.listenerForData = listener;
  }

  //allowMultipleMessages -> Si la actividad permite que un usuario conteste varias veces
  //ej -> una nube de palabras donde el usuario pueda enviar todas las palabras que desee.
  //isAddition lo que hace es que en vez de setear el nodo de los mensajes de usuario con la informacion que yo paso
  //lo que hace es agregarle informacion a lo que haya actualmente
  sendMsgActivity(
    numSlide,
    msg,
    idActivity,
    idUserPresentation,
    allowMultipleMessages = undefined,
    isAddition = false
  ) {
    this.dataConnector.sendMsgActivity(
      numSlide,
      msg,
      idActivity,
      idUserPresentation,
      this.getName(),
      this.getEmail(),
      allowMultipleMessages,
      isAddition
    );
  }

  //Setea cual es el ppt que esta abierto en el caso del electron,
  //si es iniciado sin electron es el ppt de la nube que abrí
  setPPTName(pptName) {
    //this.pptName = pptName;
    this.dispatch(setSelectedPPT(pptName, this.isCloud()));
  }

  //Cambia el index logico de la presentacion (diapositiva actual)
  //y si refreshSlide es true entonces refresca la informacion del electron
  async setSlidePosition(position, refreshSlide) {
    console.log(
      "actual",
      this.getSlideIndex(),
      position,
      this.isDonePresentation
    );
    if (this.getSlideIndex() !== position || this.isDonePresentation) {
      this.isDonePresentation = false;
      this.setIndex(position);
      this.refreshSlidePreview();

      console.log("desde aca?");
      if (refreshSlide) {
        await this.checkCurrentSlide();
      }
    }
  }

  slideShowDone() {
    console.log("llega aca " + this.inSlideShowMode);
    if (this.inSlideShowMode) {
      this.isDonePresentation = true;
      //this.setIndex( this.getSlideIndex() );
    }
  }

  slideShowEnds() {
    this.inSlideShowMode = false;

    //Ya no se cierra la sesion al terminar porque el profesor debe poder salir de las diapositivas por un momento
    //ahora lo que hace es que vuelve al MainMenu
    //this.closeCurrentSession();

    if (this.listenerForData !== null && this.listenerForData !== undefined) {
      this.listenerForData({ command: "finish" });
    }
  }

  cleanLanSession() {
    this.updateSessionClose();
    this.changeSlidePreview(
      "http://" + localHandler.getUrlServer() + "/images/nopreview.png"
    );
  }

  closeCurrentSession() {
    console.DEBUG_FLIPWIT("code closeCurrentSession: " + this.getSessionCode());

    if (
      this.getSessionCode() === "" ||
      this.getSessionCode() === null ||
      this.getSessionCode() === undefined
    )
      return;

    if (this.isLAN) {
      this.actionInPresentation("Finish");
      if (this.isExhibitor) {
        this.cleanLanSession();
      }
    } else {
      if (this.isExhibitor) {
        //Cierra la session en sails --------------------------------------------------
        var payload = {
          code: this.getSessionCode(),
          user: flipwitFirebaseConnector.loggedUser,
          name: this.getPPTName()
        };

        requestPostSail(
          process.env.REACT_APP_URL_SERVICES + "session/closeSession",
          payload,
          function(data) {}
        );

        //-----------------------------------------------------------------------------
        //Cierra la session en firebase -----------------------------------------------
        flipwitFirebaseConnector.closeSession(this.getSessionCode());
        //-----------------------------------------------------------------------------
        this.updateSessionClose();

        if (!this.isCloud() && this.isElectron) {
          this.inSlideShowMode = false;
          this.FlipwitSlideConnector.hideTogleaWindow();
          this.actionInPresentation("Finish");
        }
        //TODO mirar q solucionaba esto flipwitFirebaseConnector.removeAllListeners();

        //this.reportCurrentExhibitorScreen("SelectPresentation",{  }, true);
      } else {
        flipwitFirebaseConnector.removeAllListeners();
      }
    }
  }

  getIdActivity(currentComment, indexOfId) {
    currentComment = currentComment.replace("<br>", "\r"); //por si alguien tiene el plugin de power point viejo
    return currentComment.split("\r")[0].substring(indexOfId + 9);
  }

  async checkCurrentSlide() {
    console.DEBUG_FLIPWIT("CHECK CURRENT SLIDE " + this.inSlideShowMode);
    if (this.inSlideShowMode && this.getSlideIndex() !== -1) {
      let isCloudTemp = this.isCloud();
      let indexTemp = this.getSlideIndex();
      console.log("cual es el indexTemp: " + indexTemp);
      console.log("las notas ", this.slidesNotes);
      var currentComment = this.slidesNotes[indexTemp - 1];

      //Ha pasado en ciertas ocaciones un error que bloqueaba del todo la cuenta del usuario y era que
      //por razones no determinadas en firebase quedaba una posicion de diapositiva actual mayor a la
      //que realmente tenia la presentación,
      if (indexTemp - 1 >= this.slidesNotes.length) {
        console.log(
          "Cierro la sesión porque pido el comentario del slide",
          indexTemp,
          "y tengo maximo",
          this.slidesNotes.length
        );
        this.closeCurrentSession();
        return;
      }

      console.DEBUG_FLIPWIT(
        "y queda con <" +
          (indexTemp - 1) +
          "> - <" +
          indexTemp +
          ">" +
          currentComment
      );
      //VOY ACA

      var commentPresenter = currentComment;
      var indexOfId = currentComment.indexOf(ID_SLIDE_COMMENT);
      let idActivityTemp = "";
      var urlActivity = "";
      var titleToglea = "";
      var infoToglea = "";

      //Si es una diapositiva de toglea
      if (indexOfId !== -1) {
        idActivityTemp = this.getIdActivity(currentComment, indexOfId);

        //Envia un vacio como comentario pues esta dispositiva no debe mostrarlo
        commentPresenter = "";

        var objectAct = await this.getObjectInfoActivity(idActivityTemp);
        console.log("Continua en el flujo");

        if (objectAct !== null && objectAct !== undefined) {
          titleToglea = objectAct.title;
          infoToglea = objectAct.info;
          urlActivity = objectAct.idActivity.url;
        }

        if (this.isElectron && !isCloudTemp) {
          this.FlipwitSlideConnector.setTogleaSlideInfo(indexTemp, urlActivity);
        }
      } else {
        if (this.isElectron && !isCloudTemp) {
          this.FlipwitSlideConnector.showDrawingCanvas();
          //this.FlipwitSlideConnector.hideTogleaWindow();
        }
      }

      this.currentStateFirebase = {
        code: this.getSessionCode(),
        comment: commentPresenter,
        usersCon: this.getUsersConnected(),
        imgDrawing: this.getCurrentSlideDrawing(),
        pointer: { visible: false },
        communData: {
          idToglea: idActivityTemp,
          url: urlActivity,
          slideIndex: indexTemp,
          titleToglea: titleToglea,
          infoToglea: infoToglea,
          previewUrl: this.getCurrentPreview()
        }
      };

      this.dispatch(setSlideInfo(this.currentStateFirebase));

      //Si es electron envia el estado y si no refresca el preview, ya que la funcion de refrescar preview, luego de
      //refrescarlo envia el estado
      if (this.isElectron && !isCloudTemp) {
        console.DEBUG_FLIPWIT(
          "El preview que envia a firebase es " + this.getCurrentPreview()
        );
        this.sendState(this.currentStateFirebase);
        if (
          indexTemp === 1 ||
          this.getCurrentPreview().indexOf("images/nopreview.png") !== -1
        ) {
          this.refreshSlidePreview();
        }
      } else {
        this.refreshSlidePreview();
      }
    }
  }

  //Setea los comentarios de las diapositivas, esto se debe llamar desde el electron cuando se traen directamente
  //de un PPT o si es sin electron debe llamarse desde el listener de la info del sails, slidesNotes es un array de
  //strings
  setSlidesNotes(slidesNotes) {
    this.inSlideShowMode = true;
    this.slidesNotes = slidesNotes;

    console.log("Guarda como slideNotes", this.slidesNotes);

    this.dispatch(setStaticSlideInfo({ totalSlides: this.slidesNotes.length }));

    var idActivities = [];
    var slideIndexes = [];
    for (var i = this.slidesNotes.length - 1; i >= 0; i--) {
      var indexOfId = this.slidesNotes[i].indexOf(ID_SLIDE_COMMENT);
      var id = "";
      //Si es una diapositiva de toglea
      if (indexOfId !== -1) {
        id = this.getIdActivity(this.slidesNotes[i], indexOfId);
        idActivities.push(id);
        slideIndexes.push(i + 1);
      }
    }

    console.DEBUG_FLIPWIT("pida info " + idActivities);
    this.getInfoActivities(idActivities, slideIndexes);
  }

  getUser() {
    return flipwitFirebaseConnector.getUser();
  }

  setSlidesData(data) {
    console.DEBUG_FLIPWIT(
      "Guarda la info de las siguientes diapositivas " + JSON.stringify(data)
    );
    this.slidesData = data;

    if (this.isLAN) {
      this.dataConnector.convertUrlToBase64(this.slidesData);
    }

    //Si ya tengo toda la info de la exposicion refresca el preview
    if (this.getSessionCode() !== "") {
      if (this.getSlideIndex() === -1) {
        this.dispatch(
          setSlidePreview("https://www.flipwit.com/dist/tempApp/black.jpg")
        );
      }
      this.refreshSlidePreview();
    }
  }

  refreshSlidePreview() {
    console.log("que sucede");
    let indexTemp = this.getSlideIndex();
    if (this.slidesData.length > indexTemp - 1 && this.getSlideIndex() !== -1) {
      console.DEBUG_FLIPWIT("current " + indexTemp);
      if (this.getCurrentPreview() !== this.slidesData[indexTemp - 1].url) {
        var stringUrl = this.slidesData[indexTemp - 1].url;

        if (!this.isLAN) {
          if (stringUrl.indexOf("http") === -1) {
            this.slidesData[indexTemp - 1].url =
              process.env.REACT_APP_URL_SERVICES +
              stringUrl.substring("./assets/".length);
          }
        }

        if (this.getCurrentPreview() !== this.slidesData[indexTemp - 1].url) {
          this.dispatch(setSlidePreview(this.slidesData[indexTemp - 1].url));

          /*
          if(this.listenerForData!==null && this.listenerForData!==undefined) {
            this.listenerForData({"command":"changePreview","preview":this.getCurrentPreview()})
          }  */

          //Como se cambia el preview se actualiza el estado en firebase
          if (this.currentStateFirebase.communData) {
            this.currentStateFirebase.communData.previewUrl = this.getCurrentPreview();
            this.sendState(this.currentStateFirebase);
          }
        }
      }
    }
  }

  modifySlideData(slideIndex, url) {
    for (var i = this.slidesData.length - 1; i >= 0; i--) {
      if (this.slidesData[i].idSlide === slideIndex) {
        this.slidesData[i].url = url;
      }
    }

    this.setStateInitPresentation(1, slideIndex);
    console.DEBUG_FLIPWIT(
      "luego de cambiar a slide " +
        slideIndex +
        " por " +
        url +
        " queda todo como " +
        JSON.stringify(this.slidesData)
    );
    if (this.getSlideIndex() === slideIndex) {
      this.refreshSlidePreview();
    }
  }

  /*getSlidePreviewsUrls( ) { 

  }*/

  getInfoActivities(idActivities, slideIndexes) {
    console.DEBUG_FLIPWIT(
      "pedir actividades para pptName: " +
        this.getPPTName() +
        " con code " +
        this.getSessionCode()
    );

    if (this.isLAN) {
      localHandler.getInfoActivities(idActivities, this.callbackCreate);
      /*let tempInfo = '{"code": "' + this.getSessionCode() + '","acts": [{"active": true,"id": "59c133ad620ee69c23af8166","idActivity": {"id": "59bfebd659cb845c338393bb","url": "https://app.flipwit.com/plugins/url"},"info": {},"title": "https://goo.gl/forms/1TpZ9nzSjEi4sT6f2","urlImg": "https://www.flipwit.com/dist/tempApp/guiaURL.jpg"}]}';
      this.callbackCreate( JSON.parse( tempInfo ) );*/
    } else {
      console.log("THE CONFIG", this.getConfigPPT());
      var payload = {
        ids: idActivities,
        indexes: slideIndexes,
        code:
          (this.IStartedPresentation && this.isCloud()) ||
          (!this.isCloud() && this.isElectron)
            ? this.getSessionCode()
            : "WAIT",
        user: flipwitFirebaseConnector.loggedUser,
        uid: userHandler.getCurrentUser().auth_uid,
        name: this.getPPTName(),
        share: this.getConfigPPT().shareFinish, //remover esto luego porque ya esta la config
        config: this.getConfigPPT()
      };

      //Para el modo demo hace un fake del usuario para poder obtener los datos
      if (this.demoMode !== null) {
        payload.user = this.demoUserName;
      }

      requestPostSail(
        process.env.REACT_APP_URL_SERVICES + "activity/getInfo",
        payload,
        this.callbackCreate
      );
    }
  }

  callbackCreate = async data => {
    if (
      this.isExhibitor &&
      this.currentExhibitorScreen !== "PresentationMode"
    ) {
      if (!this.isAuditoriumMode()) {
        this.sceneManager.openScene("PresentationMode");
      }
    }
    console.DEBUG_FLIPWIT("data de CRETAE: " + JSON.stringify(data));
    this.infoActivities = data.acts;
    this.hasDomain = data.domain;

    console.log(this.getSessionCode(), "!==", data.code, data);

    if (
      (this.getSessionCode() !== data.code && data.code !== "WAIT") ||
      this.isLAN
    ) {
      //si es nueva actualice valores
      this.setSession(data.code);
      console.DEBUG_FLIPWIT("codeSession: " + this.getSessionCode());

      //Inicia el reloj
      if (this.isLAN) {
        this.presentationClockManager.start(0);
      } else {
        flipwitFirebaseConnector.getCurrentServerTime(offset => {
          this.presentationClockManager.start(0);
        });
      }
      //Como ya tiene el codigo de la sesion entonces envia el estado estatico al firebase
      this.sendStaticState({
        totalSlides: this.getTotalSlides(),
        initTime: this.dataConnector.getTimestampConstant(),
        code: this.getSessionCode(),
        pptName: this.getPPTName()
      });
    } else {
      if (this.getSessionCode() !== "") {
        flipwitFirebaseConnector.updateStaticState(this.getTotalSlides());
      }
    }

    if (!this.isLAN) {
      //Inicia el escuchador para saber luego si es una session con un cliente electron conectado
      flipwitFirebaseConnector.initElectronSessionData(this.getSessionCode());

      if (!this.isCloud()) {
        flipwitFirebaseConnector.sendActiveElectron(this.getSessionCode());
      } else {
        this.dispatch(setStateLoadingPresentation(""));
      }
    }

    await this.checkCurrentSlide();
    if (this.currentStateFirebase.communData) {
      this.sendState(this.currentStateFirebase);
    }
  };

  //Obtiene la información de una actividad TOGLEA
  async getObjectInfoActivity(idActivity) {
    if (!this.infoActivities) {
      console.error("getObjectInfoActivity: infoActivities not found!!");
      return null;
    }
    if (!idActivity) {
      console.error("getObjectInfoActivity: idActivity not defined yet!!");
      return null;
    }

    console.DEBUG_FLIPWIT(
      "va a buscar la actividad " +
        idActivity +
        " dentro de " +
        this.infoActivities.length +
        " actividades"
    );

    for (var i = this.infoActivities.length - 1; i >= 0; i--) {
      console.log("Compara con ", this.infoActivities[i].id, "y", idActivity);
      if (this.infoActivities[i].id === idActivity) {
        console.log("Poner la actividad", this.infoActivities[i]);

        if (this.infoActivities[i].info !== undefined) {
          if (this.infoActivities[i].info.reloadWhenShown === true) {
            return new Promise((resolve, reject) => {
              var payload = { id: this.infoActivities[i].id };
              console.log("La recargaria");
              requestPostSail(
                process.env.REACT_APP_URL_SERVICES + "activity/getActivityInfo",
                payload,
                data => {
                  console.log("ACTLAQUE llega", data, data.activityFound[0]);
                  if (
                    data.activityFound !== undefined &&
                    data.activityFound !== null &&
                    data.activityFound.length > 0
                  ) {
                    resolve(data.activityFound[0]);
                  } else {
                    reject();
                  }
                }
              );
            });
          }
        }

        return this.infoActivities[i];
      }
    }

    console.error(
      "ACTIVITY [" + idActivity + "] NOT FOUND",
      this.infoActivities
    );
    return null;
  }

  setElectronSession() {
    //this.isCloudPresentation = false;
    this.dispatch(setSelectedPPT(this.getPPTName(), false));
    this.electronSession = true;
    console.DEBUG_FLIPWIT("Esta session tiene un cliente electron");
  }

  signInAnonymously(nick = "", callback = null) {
    flipwitFirebaseConnector.signInAnonymously(nick, callback);
  }

  setListenerActMsgs(listener, idActivity, idUser) {
    this.dataConnector.setListenerActMsgs(listener, idActivity, idUser);
  }

  getMsgActivityUser(listener, idActivity, idUser) {
    this.dataConnector.getMsgActivityUser(listener, idActivity, idUser);
  }

  presentationStarted(name, fromCloud, idCloud) {
    console.DEBUG_FLIPWIT(
      "hay que seleccionar esta " +
        name +
        " de cloud? " +
        fromCloud +
        " id: " +
        idCloud
    );
    this.dispatch(setSelectedPPT(name, fromCloud));
    this.enableNoSleep(true);
    this.cloudPresentationID = idCloud;
    platformHandler.openScene("PresentationMode");
  }

  presentationSelected(name, fromCloud, idCloud, askConf = true) {
    console.DEBUG_FLIPWIT(
      "hay que seleccionar esta " +
        name +
        " de cloud? " +
        fromCloud +
        " id: " +
        idCloud
    );
    this.dispatch(setSelectedPPT(name, fromCloud));

    this.cloudPresentationID = idCloud;

    if (name === "") return;

    //this.setPPTName( name );
    if (this.isLAN) {
      platformHandler.openScene("PresentationMode");
    } else {
      //console.trace();
      if (askConf) this.checkConfigSlides(name);
      //this.sceneManager.openScene("MainMenu");
    }
  }

  setDispatch(dispatch) {
    this.dispatch = dispatch;
  }

  pptsOpen(ppts) {
    console.DEBUG_FLIPWIT("LLEGOOOOOOO");
    if (ppts) {
      this.dispatch(setPPTsOpen(ppts));
      if (this.isElectron) {
        //si es electron envie los datos a firebase
        this.dataConnector.sendPPTsOpen(ppts);
      }

      //si ya hay una seleccionada y luego ya no existe y soy exhibitor
      //volver a la de seleccion de ppt ( quiere decir que la cerraron )
      /*if( this.getPPTName() !== "" && this.isExhibitor ){
        if( ppts.indexOf(this.getPPTName()) === -1 ){
          this.sceneManager.openScene("SelectPresentation", {fromClosed:true});
        }
      }*/
    } else {
      this.dispatch(setPPTsOpen([]));
    }
  }

  getPptsOpen() {
    this.osHandler.getPptsOpen();
  }

  getPptsCloud() {
    if (this.isLoggedIn()) {
      var payload = {
        user: this.getUser(),
        uid: userHandler.getCurrentUser().auth_uid
      };

      var ppts = [];
      var scope = this;

      requestPostSail(
        process.env.REACT_APP_URL_SERVICES + "slides/getCloudPPTs",
        payload,
        function(data_username) {
          if (data_username.success && data_username.ppts) {            
            ppts = data_username.ppts.sort((a,b) => new Date(b.createdAt) - new Date(a.createdAt));
            scope.dispatch(setPPTsCloud(ppts));
          } else {
            console.error(data_username);
          }
        }
      );
    }
  }

  reportCurrentExhibitorScreen(
    currentScreenName,
    currentScreenData,
    shouldReportCurrentScreenChange
  ) {
    this.currentExhibitorScreen = currentScreenName;

    if (shouldReportCurrentScreenChange !== false) {
      this.dataConnector.reportCurrentExhibitorScreen(
        currentScreenName,
        currentScreenData
      );
    }
  }

  callbackCurrentScreen(currentScreenName, currentScreenData, platformHandler) {
    console.DEBUG_FLIPWIT(
      "Tiene como current a " +
        platformHandler.currentExhibitorScreen +
        " o " +
        this.currentExhibitorScreen +
        " vs " +
        currentScreenName
    );
    console.trace();

    //En demo mode no se navega a otras pantallas
    if (this.demoMode !== null) {
      return;
    }

    if (platformHandler.currentExhibitorScreen !== currentScreenName) {
      console.DEBUG_FLIPWIT(
        "Se detecto un cambio de pantalla a " + currentScreenName
      );

      if (
        currentScreenName === "MainMenu" ||
        currentScreenName === "PresentationMode"
      ) {
        platformHandler.cloudPresentationID =
          currentScreenData.cloudPresentationID;
        platformHandler.dispatch(
          setSelectedPPT(
            currentScreenData.pptName,
            currentScreenData.isCloudPresentation
          )
        );
        if (currentScreenData.configPPT) {
          platformHandler.dispatch(setSharePPT(currentScreenData.configPPT));
        }

        if (this.waitingForFirstPresenceInfo) {
          this.waitingForFirstPresenceInfo = false;
          if (currentScreenName === "PresentationMode") {
            flipwitFirebaseConnector.checkSessionClosed(
              this.onCheckSessionClosed
            );
            return;
          }
        }
      }

      this.sceneManager.openScene(currentScreenName, {
        shouldReportCurrentScreenChange: false
      });
      //TODO Actions[currentScreenName]({shouldReportCurrentScreenChange:false});
    }
    this.waitingForFirstPresenceInfo = false;
  }

  onCheckSessionClosed = value => {
    if (value) {
      this.sceneManager.openScene("SelectPresentation");
      this.waitingForFirstPresenceInfo = false;
    } else {
      this.sceneManager.openScene("PresentationMode", {
        shouldReportCurrentScreenChange: false
      });
    }
  };

  onCloseElectron() {
    this.FlipwitSlideConnector.onCloseElectron();
    flipwitFirebaseConnector.onCloseElectron();
  }

  stopClock() {
    this.presentationClockManager.stop();
  }

  /*findHeightTitleBar() {
    var titleBar = document.getElementById("appBarFlipwit");
    if( titleBar ){
      this.titleBarHeight = titleBar.clientHeight;
    }
  }*/

  activateHotPlugin = data => {
    /*
      data -> es un objeto {} con los siguientes keys
      activated:true //Si esta activado el plugin, ese decir, se muestra o no se muestra
      pluginName: el nombre del plugin para saber de donde se va a cargar
      pluginView: es la vista que se va a ver en el expositor, esta se muestra solo si no esta en fullscreen, ya que la vista de videobeam (Viewer) se muestra
                  por defecto la que este en la ruta /[pluginName]/viewer, un ejemplo de este key es 'exhibitor'
      userView: la vista que va a ver el usuario, si en el hotPlugin se quiere que no se muestre nada en el usuario se puede poner 'none', por ejemplo para que 
                el expositor pueda ver un hotPlugin como el de saber que esta respondiendo la audiencia, pero esto no afecte a los conectados
      showViewerInExhibitor: dice si debe o no mostrar algo en la pantalla del videobeam, ya que algunos plugin como el de ver las respuestas actuales no deben 
                            interferir tampoco con esta vista.
     */
    flipwitFirebaseConnector.activateHotPlugin(data);
  };

  deactivateHotPlugin = () => {
    flipwitFirebaseConnector.activateHotPlugin({ activated: false });
  };

  setListenerHotPluginInfo(
    OnHotPlugin,
    callbackTypes,
    idActivity,
    idUserPresentation
  ) {
    console.log(
      "setListenerHotPluginInfo",
      callbackTypes,
      idActivity,
      idUserPresentation
    );
    this.dataConnector.onHotPluginInfo(
      OnHotPlugin,
      callbackTypes,
      idActivity,
      idUserPresentation
    );
  }

  setHotPluginListener = (listener, idUserPresentation) => {
    console.log("--> Pone a escuchar hot de ", idUserPresentation);
    flipwitFirebaseConnector.onHotPluginChange(data => {
      this.dispatch(setHotPluginInfo(data));
      listener(data);
    }, idUserPresentation);
  };

  sendHotPluginNewInfo(listener, key, info, idActivity, idUserPresentation) {
    this.dataConnector.sendHotPluginNewInfo(
      listener,
      key,
      info,
      idActivity,
      idUserPresentation
    );
  }

  listenToAudienceQuestions = idUserPresentation => {
    this.dataConnector.listenToAudienceQuestions(objData => {
      const amount = Object.keys(objData).length;
      this.questionsData = objData;
      console.log("Hay ", amount, "preguntas");
      this.dispatch(
        setPresentationModeConfig("questionsAmountForPresentation", amount)
      );
    }, idUserPresentation);
  };

  callbackHotPlugin = (allUserConnections, amountConnections) => {
    console.DEBUG_FLIPWIT(
      "Setea amount como " + amountConnections + " " + allUserConnections
    );

    this.dispatch(setAmountConnections(amountConnections - 1));

    /*if( this.isExhibitor && this.currentExhibitorScreen == "PresentationMode" ){
      if( this.currentStateFirebase.communData ){
        this.currentStateFirebase.usersCon = this.getUsersConnected();
        this.sendState(this.currentStateFirebase);
      }
    }*/
    this.listenersUsers.forEach(listenerRef => listenerRef(allUserConnections));
  };

  checkTitleBarScene = (scene, setAll = true) => {
    let title = "";
    let showMenu = false;
    this.currentScene = scene;
    let subMenu = [];

    console.log("Check para ", scene);
    switch (scene) {
      case "Initial":
        if (setAll) {
          showMenu = true;
          this.currentExhibitorScreen = "";
        }
        break;
      case "Login":
        showMenu = false;
        title = languageManager.getLangTitle("LOGIN");

        //Si es electron en la pantalla de login no puede ir a anterior, ya que la anterior de Login es Role y en
        //electron ya no se puede unir a presentaciones.
        if (this.isElectron) {
          showMenu = true;
        }
        break;
      case "Role":
        if (setAll) {
          showMenu = true;
          this.currentExhibitorScreen = "";
          flipwitFirebaseConnector.removeAllListeners();
        }

        title = languageManager.getLangTitle("ROLESELECTION");
        //this.findHeightTitleBar();
        break;
      case "PresentationMode":
        //if( setAll ){
        showMenu = true;
        //Dice que ya se proceso un estado
        //  this.firstStateProcessed = false;
        //}
        //title = languageManager.getLangTitle("PRESENTATIONMODE");
        if (this.isLAN) {
          title = this.getUrlExhibitorLocal();
        } else {
          title = this.getTitlePresentationMode();
        }

        if (this.isElectron) {
          document.addEventListener("keydown", this.keyBoardDown);
        }

        this.slidesImgDrawingUpdated = false;

        subMenu = [];

        subMenu.push("userCount");
        subMenu.push("showConnectionHelp");
        subMenu.push("showUrlBar");
        subMenu.push("showPreview");
        subMenu.push("showDrawTools");
        subMenu.push("showLaserPointer");
        subMenu.push("countRestart");
        subMenu.push("showQuestions");
        subMenu.push("showQuickWordCloud");

        if (this.getUserConfig("arquetipoTest_active") === true) {
          subMenu.push("showArquetipoTest");
        }

        if (this.getUserConfig("tipoAprendizajeTest_active") === true) {
          subMenu.push("showTipoAprendizajeTest");
        }

        if (this.getUserConfig("showSenaTest_active") === true) {
          subMenu.push("showSenaTest");
        }

        if (this.getUserConfig("showIncubarVotes_active") === true) {
          subMenu.push("showIncubarVotes");
        }

        //subMenu.push("showQuickSurvey");
        subMenu.push("closePresentation");

        break;

      case "JoinOptions":
        title = languageManager.getLangTitle("JOINOPTIONS");
        break;
      case "UploadPresentation":
        showMenu = true;
        title = languageManager.getLangTitle("UPLOADPRESENTATION");
        break;

      case "SelectPresentation":
        if (setAll) {
          showMenu = true;
        }
        title = languageManager.getLangTitle("SELECTPRESENTATION");
        break;
      case "MainMenu":
        showMenu = false;

        console.log("Entra y showMenu", showMenu);
        if (this.isLAN) {
          title = this.getUrlExhibitorLocal();
        } else {
          title = this.getPPTName();
        }
        if (this.currentStateFirebase.communData) {
          this.currentStateFirebase.communData.previewUrl =
            process.env.REACT_APP_URL_SERVICES + "images/nopreview.png";
          if (!this.isCloud() && this.isElectron) {
            this.sendState(this.currentStateFirebase);
          }
        }
        this.dispatch(
          setSlidePreview(
            process.env.REACT_APP_URL_SERVICES + "images/nopreview.png"
          )
        );
        break;
      case "PresentationUser":
        title = "www.fwtap.com/" + this.getSessionCode();
        break;
      case "PluginViewer":
        title = languageManager.getLangTitle("PLUGINVIEWER");
        break;
      case "BlockedUser":
        title = languageManager.getLangTitle("BLOCKEDUSER");
        break;

      case "SlideEditor":
        title = languageManager.getLangTitle("SLIDE_EDITOR");
        showMenu = false;
        break;

      default:
    }

    if (scene !== "PresentationMode") {
      document.removeEventListener("keydown", this.keyBoardDown);
      let isFull = this.isFullScreen();

      if (isFull) {
        this.toggleFullScreen();
      }

      /*if( window.innerHeight == screen.height) {
       */
    }

    console.log("Deja en showMenu a ", showMenu);

    this.dispatch(setTitleBar(title, showMenu));

    //Indica si hay o no subMenu
    console.log("Al checkear ", scene, "va a dejar", subMenu);
    this.dispatch(setSubmenuInfo(subMenu));
  };

  getTitlePresentationMode() {
    return (
      languageManager.getLangWord("CODE_CONNECTION") +
      ": " +
      this.getSessionCode()
    );
  }

  backPressed() {
    this.sceneManager.backPressed();
  }

  processInitInformation() {
    var slideNotes = [];
    console.log("PROCESSS INIT", this.initInformation);

    for (var i = 0; i < this.initInformation.slides.length; i++) {
      slideNotes.push(this.initInformation.slides[i].note);
    }
    console.log("Agrego slideNotes", slideNotes);
    this.setSlidesData(this.initInformation.slides);
    this.setSlidesNotes(slideNotes);

    console.DEBUG_FLIPWIT("TERMNO PROCESS INIT INFORMATION");

    this.initInformation = null;
  }

  getFirebaseConnector() {
    return flipwitFirebaseConnector;
  }

  removeOldSession(callFirebase) {
    this.currentStateFirebase = {};
    this.slidesData = [];
    this.slidesImgDrawing = [];
    this.IStartedPresentation = false;
    this.listenFullScreen = null;

    if (!this.isLAN) {
      if (callFirebase !== false) {
        flipwitFirebaseConnector.removeOldSession();
      }
    }
  }

  setStore(getState) {
    this.getState = getState;
  }

  getStoreData = () => {
    return this.getState().containers.appReducer.currentData;
  };

  getPPTName() {
    return this.getStoreData().slideName;
  }

  isCloud() {
    return this.getStoreData().isCloud;
  }

  getSessionCode() {
    return this.getStoreData().sessionCode;
  }

  setSession(code) {
    this.dispatch(setSessionCode(code));

    if (!this.isLAN) {
      if (
        this.isExhibitor &&
        this.currentExhibitorScreen === "PresentationMode"
      ) {
        this.dispatch(setTitleBar(this.getTitlePresentationMode()));
      }
    }
  }

  getSlideIndex() {
    return this.getStoreData().indexSlide;
  }

  setIndex(indexSlide) {
    this.dispatch(setSlideIndex(indexSlide));
  }

  getCurrentIdAct() {
    return this.getStoreData().idToglea;
  }

  getCurrentPreview() {
    return this.getStoreData().previewUrl;
  }

  getTotalSlides() {
    console.log("this.getStoreData()", this.getStoreData());
    return this.getStoreData().totalSlides;
  }

  getUsersConnected() {
    return this.getStoreData().usersCount;
  }

  getExhibitorMsgs(listener, idActivity, idUser) {
    this.dataConnector.getExhibitorMsgs(listener, idActivity, idUser);
  }

  isFullScreen() {
    let fullscreenElement =
      document.fullscreenElement ||
      document.mozFullScreenElement ||
      document.webkitFullscreenElement ||
      document.msFullscreenElement;

    if (fullscreenElement !== null && fullscreenElement !== undefined) {
      return true;
    }

    return false;
  }

  keyBoardDown = e => {
    if (
      this.isExhibitor &&
      this.currentExhibitorScreen === "PresentationMode"
    ) {
      //if( this.isFullScreen() || this.isElectron ){
      //Left or PageUp
      if (e.which === 37 || e.which === 33) {
        this.actionInPresentation("Prev");
      }
      //Right or PageDown
      else if (e.which === 39 || e.which === 34) {
        this.actionInPresentation("Next");
      }
      //}
    }
  };

  toggleFullScreen(element, sendCommand = false) {
    let isFullScreenNow = this.isFullScreen();
    console.log("Llama a toggle fullscreen con ", sendCommand, isFullScreenNow);

    if (isFullScreenNow) {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }

      document.removeEventListener("keydown", this.keyBoardDown);
      /*let requestMethod = document.cancelFullScreen || document.webkitCancelFullScreen || document.mozCancelFullScreen || msExitFullscreen;

      if (requestMethod) { // Cancel full screen.
          requestMethod.call();
      }*/
    } else {
      // Supports most browsers and their versions.
      let requestMethod =
        element.requestFullScreen ||
        element.webkitRequestFullScreen ||
        element.mozRequestFullScreen ||
        element.msRequestFullScreen;

      if (requestMethod) {
        // Native full screen.
        requestMethod.call(element);
      }

      document.addEventListener("keydown", this.keyBoardDown);
      if (sendCommand) {
        //no funciona porque tiene que ser iniciado por un gesture
        this.sendCommandFullScreen();
      }

      this.osHandler.toggleFullScreen(true);
      /*else if (typeof window.ActiveXObject !== "undefined" && typeof window.ActiveXObject !== "null") { // Older IE.
          var wscript = new ActiveXObject("WScript.Shell");
          if (wscript !== null && wscript !== undefined) {
              wscript.SendKeys("{F11}");
          }
      }*/
    }
  }

  openScene(scene, params = {}) {
    this.sceneManager.openScene(scene, params);
  }

  setIStartedPresentation(value) {
    console.DEBUG_FLIPWIT("lo inicie? " + value);
    this.IStartedPresentation = value;
  }

  restartClock() {
    var temp = {
      totalSlides: this.getTotalSlides(),
      initTime: flipwitFirebaseConnector.getTimestampConstant(),
      code: this.getSessionCode(),
      pptName: this.getPPTName()
    };
    this.sendStaticState(temp);

    //this.presentationClockManager.start(0);
  }

  setPowerPointConnected(value) {
    if (value) {
      console.DEBUG_FLIPWIT("cual es actual: " + this.currentExhibitorScreen);
      if (this.currentExhibitorScreen === "SelectPresentation") {
        this.getPptsOpen();
      }
    }
  }

  toggleDevTools() {
    if (this.isElectron) {
      this.osHandler.toggleDevTools();
    }
  }

  setListenerUsersMsgs(listener) {
    this.listenersUsers.push(listener);
    if (this.allUserConnections) {
      listener(this.allUserConnections);
    }
  }

  openExternalURL = url => {
    this.osHandler.openExternalURL(url);
  };

  enableNoSleep = value => {
    if (this.isMobileApp || this.noSleepEnabled) {
      return;
    }

    var iOS =
      !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    if (iOS) {
      return;
    }

    try {
      if (value) {
        //La funcion que se pasa como callback se llama si el nosleep falla
        //entonces apaga el semaforo
        this.noSleep.enable(() => {
          this.noSleepEnabled = false;
        });
        this.noSleepEnabled = true;
      } else {
        this.noSleep.disable();
        this.noSleepEnabled = false;
      }
    } catch (e) {
      console.log("Error interno en noSleep value:", value);
    }
  };

  isNextActive = () => {
    let isActive = true;
    if (this.isCloud()) {
      if (this.getSlideIndex() === this.getTotalSlides()) {
        isActive = false;
      }
    } else {
      if (this.isDonePresentation) {
        isActive = false;
      }
    }

    return isActive;
  };

  actionInDrawing = action => {
    let command = {
      command: "drawing",
      type: action,
      owner: this.dataConnector.uniqueConnectionID
    };

    this.dataConnector.sendCommand(command);
  };

  actionInPresentation = action => {
    console.DEBUG_FLIPWIT("llega a actionInPresentation");
    console.trace();
    if (action === "Next") {
      this.enableNoSleep(true);
      if (!this.isNextActive()) {
        return;
      }
    }

    let command = {
      command: "InteractionFeature",
      interactionType: action,
      pptName: this.getPPTName()
    };

    this.executeCommand(command);
    this.updateSessionDuration();
  };

  updateSessionDuration = () => {
    var payload = {
      code: this.getSessionCode(),
      user: flipwitFirebaseConnector.loggedUser,
      name: this.getPPTName()
    };

    requestPostSail(
      process.env.REACT_APP_URL_SERVICES + "session/updateSessionDuration",
      payload,
      function(data) {}
    );
  };

  isFullScreenSupported = () => {
    var iOS =
      !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    console.log("is IPNOHE " + iOS, navigator.platform);

    if (!iOS) {
      return true;
    }

    return false;
  };

  setListenerFullScreen = listener => {
    this.listenFullScreen = listener;
  };

  sendCommandFullScreen = () => {
    flipwitFirebaseConnector.sendFullScreen();
  };

  receiveCommandFullScreen = () => {
    if (this.isFullScreenSupported()) {
      if (!this.isFullScreen()) {
        if (
          this.listenFullScreen !== null &&
          this.listenFullScreen !== undefined
        ) {
          this.listenFullScreen();
        }
      }
    }
  };

  canReceivePptsCommands = () => {
    if (
      this.currentExhibitorScreen !== "" &&
      this.currentExhibitorScreen !== "SelectPresentation" &&
      !this.isCloud()
    ) {
      return true;
    }

    return false;
  };

  //coloca en que estado va la presentacion cuando se inicia en local
  //0 -> generando previews
  //1 -> guardando previews
  //2 -> guardada
  //3 -> finalizada
  //4 -> generando pdf
  setStateInitPresentation = (state, slideIndex) => {
    // if (!this.isCloud()) {
    let textTemp = languageManager.getLangWord(
      "STATES_INIT_PRESENTATION." + state
    );
    if (state === 1 || state === 0) {
      if (slideIndex !== -1) {
        textTemp += "\n" + slideIndex + " / " + this.getTotalSlides();
      }
    } else if (state === 2) {
      this.getPptsCloud();
      setTimeout(this.finishStatePresentation, 2000);
    }
    this.dispatch(setStateLoadingPresentation(textTemp));
    // }
  };

  finishStatePresentation = () => {
    this.setStateInitPresentation(3, 1);
  };

  getUrlApp = () => {
    if (this.isLAN) {
      return this.dataConnector.getUrlServer();
    }
    return "app.flipwit.com/";
  };

  setLanguage = jsonLanguage => {
    //TEXTS = this.getLangWord;
    /*TEXTS = jsonLanguage.TEXTS;
    TEXTS_LANG = jsonLanguage.TEXTS;
    TITLES = jsonLanguage.TITLES;*/
    this.dispatch(setLanguage(jsonLanguage));
  };

  getLanguage = () => {
    return this.getState().containers.appReducer.language;
  };

  isLoggedIn = () => {
    if (
      flipwitFirebaseConnector.checkSignedIn() &&
      !flipwitFirebaseConnector.isAnonymous()
    ) {
      return true;
    }

    return false;
  };

  sendLocalMessage(jsonMessage, callback) {
    localHandler.sendMessage(jsonMessage, callback);
  }

  getDataConnector() {
    return this.dataConnector;
  }

  changeSlidePreview = url => {
    this.dispatch(setSlidePreview(url));
  };

  getUrlExhibitorLocal() {
    return this.getUrlApp() + "?control -  Password:" + this.getSessionCode();
  }

  getUrlForUser() {
    if (this.isLAN) {
      return this.getUrlApp();
    } else {
      if (this.hasDomain) {
        return this.hasDomain;
      }

      return this.getStoreData().sessionCode;
    }
  }

  debugFlipwit = msg => {
    console.log(msg);

    /* if( this.ready ){
      var payload = {
           user: flipwitFirebaseConnector.checkSignedIn()?this.getUser():'noLog',
           instance: this.instanceNumber,
           msg: ""+ msg,
           isExhibitor: this.isExhibitor,
           logNumber: this.logNumber
       };

       this.logNumber ++;
       requestPostSail( process.env.REACT_APP_URL_SERVICES + 'log/logConsole', payload, function(data){});
    }*/
  };

  startWithInternet(value) {
    if (this.isLAN !== !value) {
      this.setSession("");
    }
    this.isLAN = !value;
    this.isLocalSession = !value;

    //Al parecer esta funcion se llama para nada pues en el flujo ya se habia llamado antes e
    //internamente tiene un flag para que solo funcione una vez
    //no lo quito porque depronto trae inestabilidad -> Att. Carlos Beltran
    this.startDataConnector();
  }

  drawingChange(json) {
    this.slidesImgDrawing[this.getSlideIndex()] = json;

    this.dataConnector.updateDrawing(json);
    /*if( this.currentStateFirebase.communData ){
      this.currentStateFirebase.imgDrawing = json;
      this.sendState(this.currentStateFirebase);
    }*/

    this.dataConnector.sendImgDrawing(this.getSlideIndex(), json);

    this.updateElectronDrawing();
  }

  updateElectronDrawing = () => {
    if (this.isElectron && !this.isCloud()) {
      this.FlipwitSlideConnector.setDrawingCanvas(
        this.lc.getSnapshot(["shapes", "colors"])
      );
    }
  };

  getCurrentSlideDrawing() {
    if (this.slidesImgDrawing) {
      return this.slidesImgDrawing[this.getSlideIndex()]
        ? this.slidesImgDrawing[this.getSlideIndex()]
        : "{}";
    }

    return "{}";
  }

  setDrawingCanvas(lc, cbInit) {
    this.lc = lc;
    this.initDrawer = cbInit;
  }

  listenerForDrawingsData = data => {
    console.log("listenerForDrawingsData");
    if (data) {
      this.slidesImgDrawing = data;
    } else {
      this.slidesImgDrawing = [];
    }

    this.updateCurrentDrawing();

    this.slidesImgDrawingUpdated = true;
  };

  updateCurrentDrawing = () => {
    console.log("updateCurrentDrawing");
    var index = this.getSlideIndex();
    if (this.slidesImgDrawing && this.slidesImgDrawing[index] && this.lc) {
      this.lc.loadSnapshot(this.slidesImgDrawing[index]);

      this.updateElectronDrawing();
    }
  };

  updateListenerCurDrawing = () => {
    console.log("updateListenerCurDrawing");
    if (this.isExhibitor && this.previous !== this.getSlideIndex()) {
      this.previous = this.getSlideIndex();
      this.dataConnector.loadCurImgsDrawings(
        this.getSlideIndex(),
        this.listenerForNewDrawing,
        this.listenerForColor
      );
    }
  };

  listenerForColor = value => {
    console.log("removed ", value, this.lc);
    if (this.lc) {
      for (var color in value) {
        this.lc.setColor(color, value[color]);
      }

      this.updateElectronDrawing();
    }
  };

  listenerForNewDrawing = (idShape, data, index) => {
    if (this.slidesImgDrawingUpdated) {
      this.initSlideImgDrawing();

      //al inicio siempre carga el ultimo shape, por eso se valida siya no esta
      if (this.slidesImgDrawing[index].shapes[idShape] === undefined) {
        this.slidesImgDrawing[index].shapes[idShape] = data;

        if (this.getSlideIndex() === index) {
          if (this.lc) {
            this.lc.saveShape(LiterallyCanvas.JSONToShape(data), false);
            this.updateElectronDrawing();
          }
        }
      } else {
        console.log("already added");
      }
    }
  };

  pointerChange = (visible, x, y) => {
    //console.log('pointerChange', this.currentStateFirebase)
    //if( this.currentStateFirebase.communData ){
    let pointerObj = {
      owner: this.dataConnector.uniqueConnectionID,
      visible: visible
    };
    let data = { x: Number(x.toFixed(2)), y: Number(y.toFixed(2)) };
    this.dataConnector.updatePointer(pointerObj, data);

    if (this.isElectron && !this.isCloud()) {
      this.FlipwitSlideConnector.setPointer(visible, x, y);
    }
    //}
  };

  setUpdatePointer = cb => {
    this.updatePointer = cb;
  };

  checkPointer = data => {
    if (
      data !== null &&
      data !== undefined &&
      !data.isStaticInfo &&
      data.communData
    ) {
      console.log("checkeelo");
      if (this.updatePointer && data.pointer) {
        if (data.pointer.owner !== this.dataConnector.uniqueConnectionID) {
          this.updatePointer(data.pointer.visible, data.pointerData);

          if (this.isElectron && !this.isCloud()) {
            this.FlipwitSlideConnector.setPointer(
              data.pointer.visible,
              data.pointerData
            );
          }
        }
      }
    }
  };

  orientationChange = () => {
    if (this.lc && this.initDrawer) {
      //this.initDrawer();
    }
  };

  uniqueNumber = () => {
    var now = new Date();

    return JSON.stringify(now.getTime());
  };

  initSlideImgDrawing = () => {
    if (this.slidesImgDrawing[this.getSlideIndex()] === undefined) {
      this.slidesImgDrawing[this.getSlideIndex()] = {};
    }

    if (this.slidesImgDrawing[this.getSlideIndex()].shapes === undefined) {
      this.slidesImgDrawing[this.getSlideIndex()].shapes = [];
    }
  };

  addShapeDrawing = (classname, data, id) => {
    this.initSlideImgDrawing();

    var shapeObj = { className: classname, data: data, id: id };

    console.log("this." + this.lc.shapes.length);
    var idShape = this.lc.shapes.length - 1;

    this.slidesImgDrawing[this.getSlideIndex()].shapes[idShape] = shapeObj;

    this.dataConnector.updateDrawing(
      this.slidesImgDrawing[this.getSlideIndex()]
    );

    this.dataConnector.addShapeDrawing(this.getSlideIndex(), shapeObj, idShape);

    this.updateElectronDrawing();
  };

  actionDrawing = command => {
    if (this.lc) {
      switch (command.type) {
        case "clear":
          this.lc.clear(false);
          this.slidesImgDrawing[this.getSlideIndex()] = this.lc.getSnapshot([
            "shapes",
            "colors"
          ]);
          break;

        case "undo":
          this.lc.undo(false);
          this.slidesImgDrawing[this.getSlideIndex()] = this.lc.getSnapshot([
            "shapes",
            "colors"
          ]);
          break;

        case "redo":
          this.lc.redo(false);
          this.slidesImgDrawing[this.getSlideIndex()] = this.lc.getSnapshot([
            "shapes",
            "colors"
          ]);
          break;

        default:
      }

      this.updateElectronDrawing();

      //this.dataConnector.updateDrawing( this.lc.getSnapshot(['shapes']) );
    }
  };

  checkConfigSlides(name, callback) {
    var payload = {
      pptName: name,
      user: flipwitFirebaseConnector.loggedUser
    };

    //Si recibe por parametro un callback llama a este, si no entonces llama al propio de esta clase que esta mas abajo
    //esto se hace porque antes en Flipwit se llamaba el de abajo, pero luego con un cambio de interfaz se llamaba el de parametro
    //entonces se deja mientras la transicion
    requestPostSail(
      process.env.REACT_APP_URL_SERVICES + "slides/getConf",
      payload,
      callback || this.callbackConfigSlides
    );
  }

  callbackConfigSlides = data => {
    console.log("llega la configdf ", data.config);

    if (
      data.config &&
      data.config.shareFinish !== undefined &&
      data.config.shareFinish !== null
    ) {
      this.dispatch(setSharePPT(data.config));
      this.sceneManager.openScene("MainMenu", { config: data.config });
    } else {
      this.sceneManager.openScene("MainMenu", { config: "{}" });
    }
  };

  setConfigSlides = (value, sendToServer = true) => {
    console.log("alguien lo setea", value);
    this.dispatch(
      setSharePPT(
        is_js.empty(value) ? { shareFinish: false, nick: false } : value
      )
    );

    if (sendToServer) {
      var payload = {
        pptName: this.getPPTName(),
        user: flipwitFirebaseConnector.loggedUser,
        config: this.getConfigPPT()
      };

      console.log("Payload ", payload);

      requestPostSail(
        process.env.REACT_APP_URL_SERVICES + "slides/setConf",
        payload,
        () => {}
      );
    }
  };

  getConfigPPT() {
    console.log(
      "this.getState().containers.appReducer.configPPT",
      this.getState().containers.appReducer.configPPT
    );
    return this.getState().containers.appReducer.configPPT;
  }

  autoviewerAction = (action, data, cb) => {
    var user = "";
    if (
      flipwitFirebaseConnector.checkSignedIn() &&
      !flipwitFirebaseConnector.isAnonymous()
    ) {
      user = this.loggedUser;
    } else {
      //si no esta logueado abra la pantalla de loguearse o colocar el nick
      user = "Anonimo " + Date.now();
    }
    autoviewer.action(action, data, cb, user);
  };

  setListenerAutoviewer = listener => {
    console.log("SET LISTENER STATE", listener);
    this.listenerState = listener;
  };

  setAutoViewerData = (data, totalSlides) => {
    if (totalSlides) {
      platformHandler.enableNoSleep(true);
      this.dispatch(setStaticSlideInfo({ totalSlides: totalSlides }));
    }
    this.dispatch(setSlideInfo(data));

    if (this.listenerState) this.listenerState(true, data);
  };

  getEmail = () => {
    if (
      flipwitFirebaseConnector.checkSignedIn() &&
      !flipwitFirebaseConnector.isAnonymous() &&
      this.demoMode === null
    ) {
      return flipwitFirebaseConnector.currentUser.email;
    } else {
      if (this.emailUser !== "") {
        return this.emailUser;
      }
    }

    return "";
  };

  getName = () => {
    if (
      flipwitFirebaseConnector.checkSignedIn() &&
      !flipwitFirebaseConnector.isAnonymous() &&
      this.demoMode === null
    ) {
      return flipwitFirebaseConnector.currentUser.displayName;
    } else {
      if (this.nameUser !== "") {
        return this.nameUser;
      }
    }

    return "";
  };

  setMobileApp = platform => {
    console.log("set Mobile App " + platform);
    this.isMobileApp = true;
  };

  setHistory = history => {
    this.sceneManager.setHistory(history);
  };

  setPresentationModeScreen = refToScreen => {
    this.presentationModeScreen = refToScreen;
  };

  sendCommandToPresentationModeScreen = command => {
    if (this.presentationModeScreen) {
      this.presentationModeScreen.receiveCommandFromPlatform(command);
    }
  };

  errorConnector = () => {
    this.sceneManager.openScene("SelectPresentation", { fromDataError: true });
  };

  openWaitingScreen = urlWait => {
    this.sceneManager.openScene("WaitingSession", { urlWait });
  };

  uploadPPT = (cbState, startedFromAuditorium = false) => {
    this.FlipwitSlideConnector.uploadSlides(
      this.getPPTName(),
      cbState,
      startedFromAuditorium
    );
  };

  setCloud = isCloud => {
    const namePPT = this.getPPTName();
    const slidesCloud = this.getStoreData().cloudPPTs.find(
      slide => slide.name === namePPT
    );
    platformHandler.cloudPresentationID = slidesCloud.id;
    this.dispatch(setSelectedPPT(this.getPPTName(), isCloud));
  };

  //TODO, esta funcion se documenta porque a veces cuando un usuario estaba pegado a un dominio y por ejemplo
  //dejaba el celular con la pantalla apagada, y en ese momento el expositor cierra la presentacion y abre otra,
  //entonces cuando el usuario reactiva su telefono le llega el mensaje de cerrar presentacion y entonces esta funcion
  //le dice al Sails que cierre todas las sesiones, por lo que cierra la nueva.
  noSessionForDomain = domain => {
    /*var payload = {
      code: domain,
    };

    requestPostSail( process.env.REACT_APP_URL_SERVICES + 'session/domainNoActive', payload, data => {} );*/
  };

  setTotalSlides = total => {
    this.dispatch(setStaticSlideInfo({ totalSlides: total }));
  };

  sendQuestionsToExhibitor = () => {
    let firstPartEmail =
      '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml"> <head>  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />  <title>Flipwit</title>  <meta name="viewport" content="width=device-width, initial-scale=1.0"/></head><body style="margin: 0; padding: 0;"> <table border="0" cellpadding="0" cellspacing="0" height="100%" width="100%" id="bodyTable">      <tr>          <td align="center" valign="top">              <table border="0" cellpadding="20" cellspacing="0" width="600" id="emailContainer" >                  <tr>                      <td align="center" valign="top">                          <table border="0" cellpadding="0" cellspacing="0" width="100%" id="emailHeader" style="border-collapse: collapse;">                             <tr bgcolor="#EAEAEA">                                     <td width="160" valign="top" style="padding: 8px 2px 8px 0;">                                        <img src="http://www.flipwit.com/dist/imgs/logo.png" width="150" height="55" alt="flipwit" style="display: block;" />                                    </td>                                    <td width="10" valign="top">                                         <div style="border-left:2px solid #ADADAD;height:54px;margin: 8px 0 8px 0;"></div>                                    </td>                                      <td valign="top" style="color: #F94E01;font-family: Arial, sans-serif; font-size: 24px;padding: 21px 0 8px 6px;">                                        ${PRESENTATION_NAME}                                    </td>                                 </tr>                            </table>                            <table align="center"  cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse;">                                <tr >                                    <td style="color: #737373;font-family: Arial, sans-serif; font-size: 20px;padding: 41px 0 8px 20px;width: 100%">                                    Hola,                                    </td>                                </tr>                                <tr >                                    <td style="color: #737373;font-family: Arial, sans-serif; font-size: 20px;padding: 21px 0 8px 20px;width: 100%">                                    Acabas de tener una presentación y la audiencia te envió las siguientes preguntas                                    </td>                                </tr>                         </table>                      </td>                 </tr>                 <tr>                      <td align="center" valign="top">                          <table border="1" cellpadding="20" cellspacing="0" width="100%" id="emailBody" style="border: 1px solid #737373;">                              <tr>                                  <th width="30%" scope="col" style="color: #F94E01;padding:5px; font-family: Arial,sans-serif; font-size: 16px; line-height:20px;line-height:30px">Nombre</th>                                 <th width="70%" scope="col" style="color: #F94E01;padding:5px; font-family: Arial,sans-serif; font-size: 16px; line-height:20px;line-height:30px">Pregunta</th>                             </tr>                             ';
    const questionText =
      '<tr>                                  <td  scope="col" style="color: #737373;padding:5px; font-family: Arial,sans-serif; font-size: 16px; line-height:20px;line-height:30px">${NAME_QUESTION}</td>                                  <td scope="col" style="color: #737373;padding:5px; font-family: Arial,sans-serif; font-size: 16px; line-height:20px;line-height:30px">${QUESTION}</td>                              </tr>';
    const lastPartEmail =
      "</table>                     </td>                 </tr>             </table>          </td>     </tr> </table></body></html>";

    let html = [];
    let sendEmail = false;

    firstPartEmail = firstPartEmail.replace(
      "${PRESENTATION_NAME}",
      this.getPPTName()
    );
    firstPartEmail = firstPartEmail.replace("${USER_NAME}", this.getUser());
    html.push(firstPartEmail);

    if (this.questionsData) {
      for (var key in this.questionsData) {
        sendEmail = true;
        const questionObj = this.questionsData[key];
        let questionToAdd = questionText.replace(
          "${NAME_QUESTION}",
          questionObj.name
        );
        questionToAdd = questionToAdd.replace(
          "${QUESTION}",
          questionObj.question
        );
        html.push(questionToAdd);
      }
    }

    if (sendEmail) {
      console.log("SEND sendQuestionsToExhibitor");
      html.push(lastPartEmail);

      var payload = {
        recipient: this.getEmail(),
        subject: "Preguntas de la audiencia",
        htmlText: html.join("")
      };

      requestPostSail(
        process.env.REACT_APP_URL_SERVICES + "Session/sendEmail",
        payload,
        function(data) {}
      );
    }
  };

  checkStaticState = () => {
    this.dataConnector.loadPresentationStaticState(
      this.listenerForStateChange,
      null,
      this.getSessionCode()
    );
  };

  deleteSlides = namePPT => {
    var payload = {
      user: flipwitFirebaseConnector.loggedUser,
      namePPT
    };

    requestPostSail(
      process.env.REACT_APP_URL_SERVICES + "slides/deletePPT",
      payload,
      function(data) {
        console.log("deleted", data);
      }
    );
  };

  //------------------- Funciones para la creacion del demo online --------------------//

  fillDemoModeUser = demoId => {
    this.demoMode = {};

    this.demoMode.demoId = demoId;
    this.demoMode.demoUser = "000_demosData/demouser" + demoId;
    console.log("Mi demoID", this.demoMode.demoId);

    this.demoMode.demoUserObj = {
      active: "y",
      address: null,
      auth_uid: "",
      avatar: "",
      city: null,
      country: "US",
      created: "2019-01-01T14:46:25.000Z",
      custom_fields: null,
      daysLeft: 1000,
      displayName: "Usuario Demo",
      email: "demo@flipwit.com",
      fname: "Usuario",
      id: 1,
      lname: "Demo",
      mem_expire: "2221-01-01T04:59:00.000Z",
      membership_id: 2,
      phone: "",
      state: null,
      trial_used: 1,
      uid: "demo@flipwit.com",
      user_id: null,
      userlevel: 1,
      username: this.demoMode.demoUser
    };
  };

  /*Funcion que crea en firebase un nuevo demo*/
  createNewDemo = callbackDemoCreated => {
    console.log("Crear DEMO");
    this.demoMode = {};

    if (!flipwitFirebaseConnector.checkSignedIn()) {
      this.signInAnonymously("", () => {
        this.createNewDemoAfterLogin(callbackDemoCreated);
      });
    } else {
      this.createNewDemoAfterLogin(callbackDemoCreated);
    }
  };

  /*Esta es la funcion que crea el demo finalmente pero que se llama solo cuando ya el usuario este logueado*/
  createNewDemoAfterLogin = callbackDemoCreated => {
    flipwitFirebaseConnector.createNewDemo(demoId => {
      this.fillDemoModeUser(demoId);

      this.demoMode.demoInfo = true;
      this.initDemo();

      this.dispatch(setPresentationModeConfig("showPreview", false));

      callbackDemoCreated();
    });
  };

  connectToDemo = (codeByUrl, callbackDemoInfoRetrieved) => {
    this.demoMode = {};

    if (!flipwitFirebaseConnector.checkSignedIn()) {
      this.signInAnonymously();
    }

    let demouserId = codeByUrl.substr(4);

    console.log(
      "Va a checkear conexiones",
      flipwitFirebaseConnector.checkSignedIn()
    );

    //connections dice la cantidad de conectados que hay,
    //isMobileDemo dice si el demo fue inicialmente creado desde un mobil o desde un pc
    flipwitFirebaseConnector.checkConnectionsToDemo(
      demouserId,
      (connections, isMobileDemo) => {
        if (connections == 1) {
          this.fillDemoModeUser(demouserId);
          this.demoMode.demoInfo = true;
          this.dispatch(setPresentationModeConfig("showPreview", false));
          this.initDemo();
        } else {
          this.demoMode.demoId = demouserId;
          this.demoMode.demoUser = "000_demosData/demouser" + demouserId;
          //this.demoMode.demoInfo = true;
          //this.initDemo();
        }

        callbackDemoInfoRetrieved(connections);
      }
    );
  };

  //Funcion para iniciar el demo
  initDemo = () => {
    console.log(
      "Llama initDemo con ",
      this.demoMode.authInfo,
      this.demoMode.demoInfo
    );
    //Hay dos hilos que llaman esta función, por un lado el logueo en firebase
    //y por el otro obtener cual es la info del demo actual, entonces solo procesa todo cuando
    //ya se tienen ambas informaciones
    if (this.demoMode.authInfo != true || this.demoMode.demoInfo != true)
      return;

    this.startWithInternet(true);
    this.enableNoSleep(true);
    this.startExhibiting();

    //Si es mobile arranca un demo diferente a si lo hago desde PC
    if (this.isMobile) {
      this.presentationStarted(
        "Demo Flipwit_Mobile.pptx",
        true,
        "5c90d66ed8fca9612cdaf1d7"
      );
      //this.presentationStarted( 'Demo Flipwit.pptx', true, '5c5304966669f2316ea62ca8' );
    } else {
      this.presentationStarted(
        "Demo Flipwit.pptx",
        true,
        "5c5304966669f2316ea62ca8"
      );
    }

    // TODO: flipwitFirebaseConnector.reportAsFirstPresence(); esto viene del branch beltrandev2
    return; //para que este return?
  };

  getDemoData = () => {
    if (this.demoMode === null) return null;

    let res = Object.assign({}, this.demoMode);
    delete res["demoUserObj"];
    return res;
  };

  processDemoEvent = (typeEvent, eventData) => {
    let currentSlideIndex = this.getSlideIndex();

    switch (typeEvent) {
      case "newConnection":
        if (currentSlideIndex == 1) {
          this.executeCommand({
            command: "InteractionFeature",
            interactionType: "Goto",
            newIndex: 2
          });
        }
        break;

      default:
    }
  };

  //Con esta se une un usuario como audiencia a una de las sesiones de demo
  joinDemoSession = codeByUrl => {
    this.isExhibitor = false;

    this.finishJoiningDemo(codeByUrl);

    /*//Si no esta logueado en firebase lo hace
    if( !flipwitFirebaseConnector.checkSignedIn() ){      
      flipwitFirebaseConnector.signInAnonymously("",() => {
        this.finishJoiningDemo(codeByUrl);
      })      
    }
    else {
      this.finishJoiningDemo(codeByUrl);
    }    */
  };

  finishJoiningDemo = codeByUrl => {
    //Cuando se hace una conexion normal, el sails retorna una info para la conexion, pero
    //como este es un demo realmente el sails no se debe preguntar ya que la información retornada por este
    //haria que no se pudieran tener diferentes demos corriendo al mismo tiempo, entonces con este objeto se
    //simula esta respuesta
    let demoData = {
      domain: "",
      resp: {
        active: true,
        code: "----",
        config: {
          shareFinish: false
        },
        createdAt: "2019-01-17T12:51:52.450Z",
        id: "5c407a68a0c1092040c6302f",
        name: "Demo Flipwit.pptx",
        shareFinish: false,
        updatedAt: "2019-01-17T12:51:52.450Z",
        userFirebase: "000_demosData/demouser" + codeByUrl.substr(4),
        success: true
      },
      success: true
    };

    console.log("quiere unirse con ", demoData);
    this.dispatch(
      setDataPresentation(demoData.resp.name, demoData.resp.userFirebase)
    );
    console.log("Llamara a join");
    this.joinSession(demoData);
  };

  //------------------- Funciones para el modo auditorio --------------------//

  auditoriumAction = (action, data, cb) => {
    return auditorium.action(action, data, cb);
  };

  isAuditoriumMode = () => {
    return this.getState().containers.appReducer.auditorium.isAuditoriumMode;
  };

  callCustomSailsFunction = (callback, data, idActivity) => {
    var payload = Object.assign(
      {
        code: this.getSessionCode(),
        user: flipwitFirebaseConnector.loggedUser,
        name: this.getPPTName(),
        activity: idActivity
      },
      data
    );

    console.DEBUG_FLIPWIT("llama a url de sails para funcion custom", payload);

    requestPostSail(
      process.env.REACT_APP_URL_SERVICES + "session/customSailsFunction",
      payload,
      callback
    );
  };

  setCurrentSlidesConfig = config => {
    if (config === undefined || config === null) {
      config = {};
    }

    this.currentSlidesConfig = config;
    this.setConfigSlides(config, false);

    if (config.hideConnectionBar === true) {
      this.dispatch(setPresentationModeConfig("showUrlBar", false));
    }
  };

  deleteMsgHotPlugin = (idActivity, key, innerKey, idUserPresentation) => {
    console.log("key", key, innerKey);
    this.dataConnector.deleteMsgHotPlugin(
      key,
      innerKey,
      idActivity,
      idUserPresentation
    );
  };
  //------------------- Funciones para el slide editor --------------------//

  //Inicia la interfaz de Editor para el nombre de diapositiva y el id recibido
  initEditor = (namePPT, idCloud) => {
    this.presentationSelected(namePPT, true, idCloud, false);
    this.sceneManager.openScene("SlideEditor");
  };

  //Obtiene las diapositivas segun el id de mongo (Slides) recibido
  //cuando llega la info llama el callback
  getSlidesInfo = (idCloud, callback) => {
    var payload = {
      id: idCloud,
      user: flipwitFirebaseConnector.loggedUser
    };

    requestPostSail(
      process.env.REACT_APP_URL_SERVICES + "slides/getPresentationInfo",
      payload,
      presentationInfo => {
        console.log("Llega", presentationInfo);
        callback(presentationInfo);
      }
    );
  };

  setSlideEditor = slideEditor => {
    this.slideEditor = slideEditor;
  };
}

export let platformHandler = new PlatformHandler();



// WEBPACK FOOTER //
// ./src/containers/platforms/PlatformHandler.js